import React, { useContext } from "react";


import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";


import "./index.css";
import "./chart.css";
import "./step.css";


import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";

import Home from "./components/Dashboard/Home";
import DashboardDark from "./components/Dashboard/DashboardDark";
import GuestList from "./components/Dashboard/GuestList";
import GuestDetails from "./components/Dashboard/GuestDetails";
import ConciergeList from "./components/Dashboard/ConciergeList";
import RoomList from "./components/Dashboard/RoomList";
import Reviews from "./components/Dashboard/Reviews";
import Task from "./components/Dashboard/Task";


import Theme1 from "./components/Dashboard/Demo/Theme1";
import Theme2 from "./components/Dashboard/Demo/Theme2";
import Theme3 from "./components/Dashboard/Demo/Theme3";
import Theme4 from "./components/Dashboard/Demo/Theme4";
import Theme5 from "./components/Dashboard/Demo/Theme5";
import Theme6 from "./components/Dashboard/Demo/Theme6";



import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";


import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";


import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";

import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";


import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";


import Select2 from "./components/PluginsMenu/Select2/Select2";

import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";


import Todo from "./pages/Todo";


import Widget from "./pages/Widget";


import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import DataTable from "./components/table/DataTable";
import BootstrapTable from "./components/table/BootstrapTable";


import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";


import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import Setting from "./layouts/Setting";
import { ThemeContext } from "../context/ThemeContext";
import Video from "./components/Dashboard/Video";
import Contact from "./components/Dashboard/Contact";
import AstrologerList from "./components/Astrologers/AstrologerList";
import AstrologerAdd from "./components/Astrologers/AstrologerAdd";
import Horoscope from "./components/Horoscope/Horoscope";
import HomeSlider from "./components/HomeSlider/HomeSlider";
import Wallet from "./components/Dashboard/Wallet/Wallet";
import SkillsListTable from "./components/ListTable/SkillsListTable";
import BlogList from "./components/Blog/BlogList";
import BlogAdd from "./components/Blog/BlogAdd";
import LanguagesListTable from "./components/ListTable/LanguagesListTable";
import BlogCategory from "./components/ListTable/BlogCategory";
import DregeeDiploma from "./components/ListTable/DregeeDiploma";
import AstrologersCategory from "./components/ListTable/AstrologersCategory";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import CategoryNotification from "./components/PushNotification/CategoryNotification";
import DataPushNotification from "./components/PushNotification/DataPushNotification";
import PoojaFor from "./components/PoojaFor/PoojaFor";
import PoojaList from "./components/PoojaFor/PoojaList";
import PoojaListAdd from "./components/PoojaFor/PoojaListAdd";
import GemstoneCategory from "./components/Gemstone/GemstoneCategory";
import GemstoneList from "./components/Gemstone/GemstoneList";
import GemstoneAdd from "./components/Gemstone/GemstoneAdd";

import GemstoneUserList from "./components/Gemstone/GemstoneUserList";
import GemstoneCartList from "./components/Gemstone/GemstoneCartList";
import GemstoneUserAdd from "./components/Gemstone/GemstoneUserAdd";
import CallHistory from "./components/CallHistory/CallHistory";
import AstroFilter from "./components/AstroFilter/AstroFilter";
import UserFilter from "./components/UserFilter/UserFilter";
import ExpenseCategory from "./components/ExpenseCategory/ExpenseCategory";
import IncomeCategory from "./components/IncomeCategory/IncomeCategory";
import TicketCategory from "./components/TicketCategory/TicketCategory";
import TodayChatCount from "./components/TodayChatCount/TodayChatCount"
import OnlinePujaFilter from "./components/OnlinePujaFilter/OnlinePujaFilter";
import GemstoneFilter from "./components/GemstoneFilter/GemstoneFilter";
import TodayCallCountFilter from "./components/TodayCallCountFilter/TodayCallCountFilter";
import UserList from "./components/UserList/UserList";
import AdminUser from "./components/AdminUser/AdminUser";
import AdminUserList from "./components/AdminUser/AdminUserList";
import ExpenseDetails from "./components/ExpenseDetails/ExpenseDetails";
import Mohorat from "./components/Mohorat/Mohorat";
import Muhurat from "./components/ListTable/Muhurat";
import Loader from "./components/Loader/Loader";
import ProtectedRoute from "../components/ProtectedRoute";
import TransactionCategory from "./components/ListTable/TransactionCategory";
import CompanyTransaction from "./components/CompanyTransaction/CompanyTransaction";
import VratUpvaas from "./components/ListTable/VratUpvaas";
import VratUpvaasMain from "./components/VratUpvaas/VratUpvaasMain";
import PaymentHistory from "./components/PaymentHistory/PaymentHistory";
import UserWalletTransaction from "./components/UserWalletTransaction/UserWalletTransaction";
import AstrowalletTransaction from "./components/AstroWalletTransaction/AstrowalletTransaction";
import AddCompany from "./components/AddCompany/AddCompany";
import NotificationRule from "./components/PushNotification/NotificationRule";
import PaymentPageVisitors from "./components/PaymentPageVisitors/PaymentPageVisitors";
import AstrologerPriceChange from "./components/AstrogolerPriceChage/AstrologerPriceChange";
import AstrologerGallary from "./components/AstrologerGallary/AstrologerGallary";
import UserReview from "./components/UserReview/UserReview";
import { components } from "react-select";
import NotLoginUser from "./components/NotLoginUsers/NotLoginUser";
import AllMenuPages from "./components/AllMenuPages/AllMenuPages";
import Festival from "./components/Festival/Festival";
import NotificationRuleList from "./components/PushNotification/NotificationRuleList";
import AddExpenseEntry from "./components/ExpenseEntry/AddExpenseEntry";
import IncomeCategoryAdd from "./components/IncomeCategory/IncomeCategoryAdd";
import Support from "./components/Support/Support";
import VideoPage from "./components/VideoPage/VideoPage";
import BlockedAstrologer from "./components/Astrologers/BlockedAstrologer";
import WaitingList from "./components/Astrologers/WaitingList";
import AstrologerBlocklist from "./components/Astrologers/AstrologerBlocklist";
import RedirectCategory from "./components/PushNotification/RedirectCategory";
import AuthorAdd from "./components/Blog/AuthorAdd";
import PendingApporeved from "./components/Astrologers/PendingApporeved";
import WeeklyCalendar from "./components/Astrologers/WeeklyCalendar";
import AstrologerLiveStatus from "./components/Astrologers/AstrologerLiveStatus";
import Suggestion from "./components/Astrologers/Suggestion";
import SuggestionGemstone from "./components/Astrologers/SuggestionGemstone";
import NotificationHistory from "./components/PushNotification/NotificationHistory";
import PackageRoles from "./components/Dashboard/Wallet/PackageRoles";
import OtpVerify from "./pages/OtpVerify";
import UserActivityRules from "./components/UserActivityLogs/UserActivityRules";
import ChatHistoryAnalysis from "./components/TodayChatCount/ChatHistoryAnalysis";
import AstrologerSummery from "./components/Astrologers/AstrologerSummery.js";
import DailyIncomeSummery from "./components/Summary/DailyIncomeSummery.jsx";
import WalletPackageName from "./components/ListTable/WalletPackageName.jsx";
import ServiceProvider from "./components/ServiceProvider/ServiceProvider.jsx";
import UserSummery from "./components/UserSummery/UserSummery.jsx"
import NotificationMessage from "./components/PushNotification/NotificationMessage.jsx";
import NotificationQueue from "./components/PushNotification/NotificationQueue.jsx";
import NotificationTracking from "./components/PushNotification/NotificationTracking.jsx";
import DailySummery from "./components/DailySummeryReport/DailySummery.jsx";
import PendingCallChat from "./components/CallHistory/PendingCallChat.jsx";
import Peakcallchat from "./components/UserRegpeakhour/UserRegpeackhour.jsx";
import MarketingContacts from "./components/MarketingContacts/MarketingContacts.jsx";
import ListMarketingcontact from "./components/MarketingContacts/ListMarketingcontact.jsx";
import WaitingListHistory from "./components/Astrologers/WaitingListHistory.js";
import MostAcivityPage from "./components/Astrologers/MostAcivityPage.js";
import AstrologerSalary from "./components/Astrologers/AstrologerSalary.js";
import AstrologerTotalTime from "./components/Astrologers/AstrologerTotalTime.js";
import AstrologerGiftCard from "./components/Astrologers/AstrologerGiftCard.js";
import AstroVideoStreamingPrice from "./components/AstrogolerPriceChage/AstroVideoStrimingPrice.jsx";
import RoleBaseAccess from "./components/RoleBaseAccess/RoleBaseAccess.jsx";
import IncomeTransaction from "./components/IncomeTransaction/IncomeTransaction.js";
import AtrologerProfilePhoto from "./components/AstrologerProfilePhoto/AstrologerProfilePhoto.js";
import UserRegAge from "./components/UserRegAge/UserRegAge.js";
import CallChatStatus from "./components/CallChatStatus/CallChatStatus.js";
import AstrologerMobilenoSend from "./components/AstrologerMobilenoSend/AstrologerMobilenoSend.jsx";
import InterpretationCategory from "./components/Astrology interpretation/interpretationCategory.jsx";
import TopicWiseNotification from "./components/PushNotification/TopicWiseNotification.jsx";
import InterpretationRule from "./components/Astrology interpretation/InterpretationRule.jsx";
import TopicWiseRules from "./components/PushNotification/TopicWiseRules.jsx";
import TopicWiseRulesCategory from "./components/PushNotification/TopicWiseCategory.jsx";
import CouponCode from "./components/CouponCode/CouponCode.jsx";






const Markup = () => {

  const authState = useSelector((state) => state.auth);
  const designation = (authState?.auth?.DesignationName || authState?.auth?.designation || authState?.auth?.Designation || '').toString().toLowerCase();

  const allroutes = [

    { url: "", component: <Home /> },
    { url: "dashboard", component: <Home /> },
    { url: "dashboard-dark", component: <DashboardDark /> },
    { url: "guest-list", component: <GuestList /> },
    { url: "guest-details", component: <GuestDetails /> },
    { url: "concierge-list", component: <ConciergeList /> },
    { url: "room-list", component: <RoomList /> },
    { url: "reviews", component: <Reviews /> },
    { url: "Feedback", component: <Task /> },
    { url: "userlist", component: <UserList />, screenCode: "U018" },
    { url: "adminuser", component: <AdminUser />, screenCode: "A070" },
    { url: "adminuserlist", component: <AdminUserList />, screenCode: "A070" },
    { url: "Contact", component: <Contact />, screenCode: "S085" },
    { url: "userwalletTransaction", component: <UserWalletTransaction />, screenCode: "U024" },
    { url: "Horoscope", component: <Horoscope />, screenCode: "B046" },
    { url: "notificationrulelist", component: <NotificationRuleList />, screenCode: "N059" },
    { url: "HomeSlider", component: <HomeSlider />, screenCode: "S087" },
    { url: "Wallet", component: <Wallet />, screenCode: "F049" },
    { url: "userreview", component: <UserReview />, screenCode: "U023" },
    { url: "notloginuser", component: <NotLoginUser />, screenCode: "U019" },
    { url: "Tickets", component: <Support />, screenCode: "U025" },
    { url: "notificationhistory", component: <NotificationHistory />, screenCode: "N064" },

    { url: "packageroles", component: <PackageRoles />, screenCode: "F050" },

    { url: "useractivityrules", component: <UserActivityRules />, screenCode: "U026" },
    { url: "primary-sidebar", component: <Theme1 /> },
    { url: "chathistoryanalysis", component: <ChatHistoryAnalysis />, screenCode: "C030" },
    { url: "mini-primary-sidebar", component: <Theme2 /> },
    { url: 'astorlogersummery', component: <AstrologerSummery />, screenCode: "A009" },
    { url: "compact-primary-header", component: <Theme3 /> },
    { url: 'walletpackagename', component: <WalletPackageName />, screenCode: "F051" },
    { url: "horizontal-primary-sidebar", component: <Theme4 /> },
    { url: 'serviceprovider', component: <ServiceProvider />, screenCode: "F055" },
    { url: "horizontal-modern-sidebar", component: <Theme5 /> },
    { url: "modern-sidebar", component: <Theme6 /> },

    { url: 'notificationmessage', component: <NotificationMessage />, screenCode: "N062" },
    { url: 'notificationqueue', component: <NotificationQueue />, screenCode: "N063" },
    { url: 'notificationtraking', component: <NotificationTracking />, screenCode: "N065" },
    { url: "astrolist", component: <AstrologerList />, screenCode: "A002" },
    { url: "astrohome", component: <AstrologerAdd /> },
    { url: "weeklycalendar", component: <WeeklyCalendar />, screenCode: "A015" },
    { url: "astrologerLiveStatus", component: <AstrologerLiveStatus />, screenCode: "A016" },

    { url: "policy", component: <PrivacyPolicy />, screenCode: "S089" },




    { url: 'callchatpeachour', component: <Peakcallchat />, screenCode: "U022" },
    { url: "marketingcontacts", component: <MarketingContacts />, screenCode: "C032" },
    { url: "listmarketingcontact", component: <ListMarketingcontact />, screenCode: "C033" },
    { url: "waitinglisthistory", component: <WaitingListHistory />, screenCode: "A010" },
    { url: "mostactivitypage", component: <MostAcivityPage />, screenCode: "A011" },
    { url: "astrologersalary", component: <AstrologerSalary />, screenCode: "A008" },
    { url: "astrototaltime", component: <AstrologerTotalTime />, screenCode: "A011" },
    { url: "astrologergiftcard", component: <AstrologerGiftCard />, screenCode: "A012" },
    { url: "astrovideopricechange", component: <AstroVideoStreamingPrice />, screenCode: "A006" },
    { url: "rolebaseaccess", component: <RoleBaseAccess />, screenCode: "A071" },
    { url: "app-profile", component: <AppProfile /> },
    { url: "post-details", component: <PostDetails /> },
    { url: "email-compose", component: <Compose /> },
    { url: "email-inbox", component: <Inbox /> },
    { url: "email-read", component: <Read /> },
    { url: "app-calender", component: <Calendar /> },


    { url: "chart-sparkline", component: <SparklineChart /> },
    { url: "chart-chartjs", component: <ChartJs /> },

    { url: "chart-apexchart", component: <ApexChart /> },
    { url: "chart-rechart", component: <RechartJs /> },


    { url: "ui-alert", component: <UiAlert /> },
    { url: "ui-badge", component: <UiBadge /> },
    { url: "ui-button", component: <UiButton /> },
    { url: "ui-modal", component: <UiModal /> },
    { url: "ui-button-group", component: <UiButtonGroup /> },
    { url: "ui-accordion", component: <UiAccordion /> },
    { url: "ui-list-group", component: <UiListGroup /> },
    { url: "ui-card", component: <UiCards /> },
    { url: "ui-carousel", component: <UiCarousel /> },
    { url: "ui-dropdown", component: <UiDropDown /> },
    { url: "ui-popover", component: <UiPopOver /> },
    { url: "ui-progressbar", component: <UiProgressBar /> },
    { url: "ui-tab", component: <UiTab /> },
    { url: "ui-pagination", component: <UiPagination /> },
    { url: "ui-typography", component: <UiTypography /> },
    { url: "ui-grid", component: <UiGrid /> },


    { url: "uc-select2", component: <Select2 /> },

    { url: "uc-sweetalert", component: <MainSweetAlert /> },
    { url: "uc-toastr", component: <Toastr /> },
    { url: "map-jqvmap", component: <JqvMap /> },
    { url: "uc-lightgallery", component: <Lightgallery /> },


    { url: "todo", component: <Todo /> },



    { url: "widget-basic", component: <Widget /> },


    { url: "ecom-product-grid", component: <ProductGrid /> },
    { url: "ecom-product-list", component: <ProductList /> },
    { url: "ecom-product-detail", component: <ProductDetail /> },
    { url: "ecom-product-order", component: <ProductOrder /> },
    { url: "ecom-checkout", component: <Checkout /> },
    { url: "ecom-invoice", component: <Invoice /> },
    { url: "ecom-customers", component: <Customers /> },


    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },


    { url: 'table-filtering', component: <FilteringTable /> },
    { url: 'table-sorting', component: <SortingTable /> },
    { url: "table-datatable-basic", component: <DataTable /> },
    { url: "table-bootstrap-basic", component: <BootstrapTable /> },



    { url: "PoojaFor", component: <PoojaFor />, screenCode: "O035" },
    { url: "PoojaList", component: <PoojaList />, screenCode: "O036" },
    { url: "PoojaListAdd", component: <PoojaListAdd />, screenCode: "O037" },



    { url: "AddExpenseEntry", component: <AddExpenseEntry />, screenCode: "F054" },



    { url: "skillsList", component: <SkillsListTable />, screenCode: "S076" },
    { url: "LanguagesList", component: <LanguagesListTable />, screenCode: "S077" },
    { url: "BlogCategoryList", component: <BlogCategory />, screenCode: "B044" },
    { url: "DregeeDiploma", component: <DregeeDiploma />, screenCode: "S078" },
    { url: "AstrologersCategory", component: <AstrologersCategory />, screenCode: "S079" },




    { url: "Blog", component: <BlogList />, screenCode: "B043" },
    { url: "BlogHome", component: <BlogAdd /> },


    { url: "CategoryNotification", component: <CategoryNotification /> },
    { url: "DataPushNotification", component: <DataPushNotification /> },
    { url: "NotificationRule", component: <NotificationRule />, screenCode: "N060" },


    { url: "Gemstone", component: <GemstoneCategory />, screenCode: "G040" },
    { url: "GemstoneList", component: <GemstoneList />, screenCode: "G039" },
    { url: "GemstoneAdd", component: <GemstoneAdd /> },
    { url: "GemstoneUserList", component: <GemstoneUserList /> },
    // {url:"GemstoneOrderList", component: <GemstoneOrderList/>},
    { url: "GemstoneCartList", component: <GemstoneCartList /> },
    { url: "GemstoneUserAdd", component: <GemstoneUserAdd /> },

    // Call 
    // {url:"CallHistory", component: <CallHistory/>},
    // Filters
    { url: "UserFilter", component: <UserFilter /> },
    { url: "ChatHistory", component: <TodayChatCount />, screenCode: "C029" },
    { url: "PujaListFilter", component: <OnlinePujaFilter /> },
    { url: "GemstoneListFilter", component: <GemstoneFilter />, screenCode: "G041" },
    { url: "CallHistory", component: <TodayCallCountFilter />, screenCode: "C028" },

    // filter data dashboard 
    { url: "AstroFilter", component: <AstroFilter /> },
    { url: "ExpenseCategory", component: <ExpenseCategory />, screenCode: "F053" },
    { url: "ExpenseDetails", component: <ExpenseDetails />, screenCode: "F052" },

    { url: "IncomeCategory", component: <IncomeCategory />, screenCode: "S084" },
    //abhi
    { url: "IncomeCategoryAdd", component: <IncomeCategoryAdd />, screenCode: "F048" },

    { url: "TicketCategory", component: <TicketCategory />, screenCode: "S088" },


    { url: "adminuser", component: <AdminUser /> },

    { url: "adminuserlist", component: <AdminUserList /> },

    { url: "Muhurat", component: <Mohorat />, screenCode: "S090" },
    { url: "MuhuratCategory", component: <Muhurat />, screenCode: "S080" },

    { url: "loader", component: <Loader /> },
    { url: "TransactionCategory", component: <TransactionCategory />, screenCode: "S083" },
    { url: "Transaction", component: <CompanyTransaction />, screenCode: "C067" },

    { url: "Addcompany", component: <AddCompany />, screenCode: "F057" },




    { url: "VratUpvaasCategory", component: <VratUpvaas />, screenCode: "S081" },
    { url: "VratUpvaas", component: <VratUpvaasMain />, screenCode: "S091" },



    { url: "paymenthistory", component: <PaymentHistory /> },
    { url: "videoPage", component: <VideoPage /> },
    { url: "userwalletTransaction", component: <UserWalletTransaction /> },
    { url: "AstrowalletTransaction", component: <AstrowalletTransaction />, screenCode: "A007" },

    { url: "paymentpagevisitors", component: <PaymentPageVisitors />, screenCode: "U020" },
    { url: "astrologerpricechange", component: <AstrologerPriceChange />, screenCode: "A005" },
    { url: "astrogallery", component: <AstrologerGallary />, screenCode: "A003" },
    { url: "userreview", component: <UserReview /> },

    { url: "allmenupages", component: <AllMenuPages />, screenCode: "A073" },
    { url: "festival", component: <Festival />, screenCode: "S092" },
    { url: "notificationrulelist", component: <NotificationRuleList /> },
    { url: "asrologerblocklist", component: <BlockedAstrologer /> },
    { url: "waitinglist", component: <WaitingList />, screenCode: "A003" },
    { url: "astrologerblocklist", component: <AstrologerBlocklist />, screenCode: "A004" },
    { url: "redirectcategory", component: <RedirectCategory />, screenCode: "N061" },
    { url: "authorname", component: <AuthorAdd />, screenCode: "B045" },
    { url: "pendingapporeval", component: <PendingApporeved />, screenCode: "A004" },
    { url: "suggestionpoja", component: <Suggestion />, screenCode: "A014" },
    { url: "suggestiongemstone", component: <SuggestionGemstone />, screenCode: "A013" },
    { url: "notificationhistory", component: <NotificationHistory /> },
    { url: "packageroles", component: <PackageRoles /> },
    { url: "useractivityrules", component: <UserActivityRules /> },
    { url: "chathistoryanalysis", component: <ChatHistoryAnalysis /> },
    { url: 'astorlogersummery', component: <AstrologerSummery /> },
    { url: 'dailyincomesummary', component: <DailyIncomeSummery /> },
    { url: 'walletpackagename', component: <WalletPackageName /> },
    { url: 'serviceprovider', component: <ServiceProvider /> },
    { url: 'usersummery', component: <UserSummery />, screenCode: "U021" },
    { url: 'notificationmessage', component: <NotificationMessage />, screenCode: "N062" },
    { url: 'notificationqueue', component: <NotificationQueue />, screenCode: "N063" },
    { url: 'notificationtraking', component: <NotificationTracking /> },
    { url: 'dailysummeryreport', component: <DailySummery />, screenCode: "A072" },
    { url: 'pendingcallchat', component: <PendingCallChat />, screenCode: "C031" },

    { url: "marketingcontacts", component: <MarketingContacts /> },
    { url: "listmarketingcontact", component: <ListMarketingcontact /> },
    { url: "waitinglisthistory", component: <WaitingListHistory /> },
    { url: "mostactivitypage", component: <MostAcivityPage />, screenCode: "A074" },
    { url: "astrologersalary", component: <AstrologerSalary />, screenCode: "A008" },
    { url: "astrototaltime", component: <AstrologerTotalTime />, screenCode: "A011" },
    { url: "astrologergiftcard", component: <AstrologerGiftCard /> },
    { url: "astrovideopricechange", component: <AstroVideoStreamingPrice />, screenCode: "A006" },
    { url: "rolebaseaccess", component: <RoleBaseAccess /> },
    {url:"IncomeTransaction", component:<IncomeTransaction/>, screenCode:"F093"},
    {url:"astroprofilephoto", component:<AtrologerProfilePhoto/>, screenCode:"A094"},
    {url:"UserRegAge",component:<UserRegAge/>, screenCode:"U095"},
    {url:"callchatstatus",component:<CallChatStatus/>,screenCode:"U096"},
    {url:"astrologermobileno",component:<AstrologerMobilenoSend/>,screenCode:"A097"},
    {url:"interpretationcategory", component:<InterpretationCategory/>,screenCode:"S098"}, 
    {url:"topicwisenotification", component:<TopicWiseNotification/>, screenCode:"N100"},
    {url:"interpretationrules",component:<InterpretationRule/>, screenCode:"S099"},
    {url:"topicwiserules",component:<TopicWiseRules/>, screenCode:"N101"},
    {url:"topicwiserulescategory", component:<TopicWiseRulesCategory/>, screenCode:"N102"},
    {url:"couponcode", component:<CouponCode />,screenCode:"U103"},
    
    

  ];

  const allowedRoutes = designation === 'ca'
    ? [
      { url: "", component: <CompanyTransaction /> },
      { url: "Transaction", component: <CompanyTransaction /> },
      { url: "ExpenseDetails", component: <ExpenseDetails /> },
    ]
    : allroutes;

  const fallbackRoute = designation === 'ca'
    ? <Route path='*' element={<Navigate to="/Transaction" replace />} />
    : null;

  return (
    <>
      <Routes>
        <Route path='page-lock-screen' element={<LockScreen />} />
        <Route path='page-error-400' element={<Error400 />} />
        <Route path='page-error-403' element={<Error403 />} />
        <Route path='page-error-404' element={<Error404 />} />
        {/* <Route path='*' element={<Error404 />} /> */}
        <Route path='page-error-500' element={<Error500 />} />
        <Route path='page-error-503' element={<Error503 />} />
        <Route path='otp' element={<OtpVerify />} />
        <Route element={<MainLayout />} >
          {allowedRoutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.screenCode ? (
                <ProtectedRoute screenCode={data.screenCode}>{data.component}</ProtectedRoute>
              ) : (
                data.component
              )}
            />
          ))}
          {fallbackRoute}
        </Route>
      </Routes>
      <Setting />
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${menuToggle ? "menu-toggle" : ""}`}>
      <Nav />
      
      <div className="content-body ck-sticky-panel__content_sticky">
        <div className="container-fluid ">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  )

};
export default Markup;

